import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import NewPurchaseForm from './NewPurchaseForm';
import alert from 'alertify.js';
import { SubmissionError } from 'redux-form';

import axios from './../../../constants/axios';
import * as contactActions from './../../../actions/contactActions';

class NewPurchase extends React.Component {

   constructor(props) {
      super(props);
      this.handleSubmit = this.handleSubmit.bind(this);

   }

   handleSubmit(values) {
      const dataToSend = {
         contact_id: values.contact_id,
         contact_address_id: values.contact_address_id,
         items: values.items
      };
      if (values.memo) {
         dataToSend.memo = values.memo;
      }
      return axios.post('/inventoryPurchases', dataToSend)
         .then((res) => {
            alert.success('invoice created.');
            this.context.router.push('/purchase/purchaseInvoiceDetail/' + res.data);
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw  new SubmissionError(err.response.data);
            } else {
               alert.error('Something not right. Rasel, where are you?');
            }
         });
   }


   render() {
      return (
         <div className="NewPurchase" >
            <NewPurchaseForm submit={this.handleSubmit} />
         </div >
      );
   }
}

NewPurchase.propTypes = {
   history: PropTypes.object
};
NewPurchase.contextTypes = {
   router: PropTypes.object.isRequired
};

function mapStateToProps(state) {
   return {
      contacts: state.contacts
   };
}

function mapDispatchToProps(dispatch) {
   return {
      actions: bindActionCreators(contactActions, dispatch)
   };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewPurchase);



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Purchase/NewPurchase.js
 **/